import { createContext, useContext, useState, useMemo, useCallback, useEffect } from "react";
import { presets } from "../lib/dates";
import client from "../lib/api";

const FiltersContext = createContext(null);

export const FiltersProvider = ({ children }) => {
  const all = useMemo(() => presets(), []);
  const [preset, setPreset] = useState("ytd");
  const [dateFrom, setDateFrom] = useState(all.ytd.from);
  const [dateTo, setDateTo] = useState(all.ytd.to);
  const [refreshKey, setRefreshKey] = useState(0);

  // Multi-company support
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]); // [] = all

  useEffect(() => {
    client
      .get("/companies")
      .then((r) => {
        const list = r.data?.data || [];
        setCompanies(list);
        // Default: select all
        setSelectedCompanyIds(list.map((c) => c.id));
      })
      .catch(() => {});
  }, []);

  const applyPreset = useCallback((key) => {
    const p = presets()[key];
    if (!p) return;
    setPreset(key);
    setDateFrom(p.from);
    setDateTo(p.to);
  }, []);

  const applyCustom = useCallback((from, to) => {
    setPreset("custom");
    setDateFrom(from);
    setDateTo(to);
  }, []);

  const triggerRefresh = useCallback(() => setRefreshKey((n) => n + 1), []);

  const toggleCompany = useCallback((id) => {
    setSelectedCompanyIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  }, []);

  const selectAllCompanies = useCallback(() => {
    setSelectedCompanyIds(companies.map((c) => c.id));
  }, [companies]);

  return (
    <FiltersContext.Provider
      value={{
        preset, dateFrom, dateTo, refreshKey,
        applyPreset, applyCustom, triggerRefresh,
        companies, selectedCompanyIds,
        toggleCompany, selectAllCompanies,
        setSelectedCompanyIds,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = () => useContext(FiltersContext);
